export const USER_ID = 'userId';
export const IS_SIGN_IN_FORM_OPEN = 'isSignInFormOpen';
export const EMAIL_VERIFIED = 'isEmailVerified';
export const GUEST_EMAIL = 'guestEmail';
export const EMAIL = 'email';
export const BIRTH_DATE = 'birth.date';
export const GET_USER_CREATION_DATE = 'get.user.creation.date';
export const GET_FORMATTED_ADDRESS = 'get.user.formatted.address';

export interface IGetFormattedAddress {
    metadataId: string;
    attributes: {
        [field: string]: string;
    };
}

export type ServiceUserProfileQueries = {
    [USER_ID]: undefined;
    [IS_SIGN_IN_FORM_OPEN]: undefined;
    [EMAIL_VERIFIED]: undefined;
    [GUEST_EMAIL]: undefined;
    [EMAIL]: undefined;
    [BIRTH_DATE]: undefined;
    [GET_USER_CREATION_DATE]: undefined;
    [GET_FORMATTED_ADDRESS]: IGetFormattedAddress;
};

export type ServiceUserProfileQueriesResponseType = {
    [USER_ID]: string;
    [IS_SIGN_IN_FORM_OPEN]: boolean;
    [EMAIL_VERIFIED]: boolean;
    [GUEST_EMAIL]: string;
    [EMAIL]: string;
    [BIRTH_DATE]: string;
    [GET_USER_CREATION_DATE]: string;
    [GET_FORMATTED_ADDRESS]: Promise<string>;
};
